/**
 * authSessionState — "has AuthSessionSync finished its first session check?"
 *
 * Module-level so `RequireAuth` can read it without a store dependency.
 * Pending is true only between AuthSessionSync mounting and its first
 * `getSession()` resolving; everywhere else (tests, no Supabase) it is false,
 * which preserves the gate's previous behaviour.
 */

import { useSyncExternalStore } from 'react';

let sessionCheckPending = false;
const listeners = new Set<() => void>();

export function setSessionCheckPending(next: boolean): void {
  if (sessionCheckPending === next) return;
  sessionCheckPending = next;
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useSessionCheckPending(): boolean {
  return useSyncExternalStore(subscribe, () => sessionCheckPending, () => false);
}
